// extracted by mini-css-extract-plugin
export var addButton = "_n2-0";
export var border = "_n2-8";
export var check = "_n2-h";
export var danger = "_n2-6";
export var dropdownContainer = "_n2-1";
export var editModalBody = "_n2-j";
export var footerContainer = "_n2-i";
export var fullWidth = "_n2-a";
export var hide = "_n2-9";
export var icon = "_n2-3";
export var input = "_n2-7";
export var inputFlex = "_n2-b";
export var inputWrapper = "_n2-c";
export var manualFocus = "_n2-5";
export var optionButton = "_n2-4";
export var pillWrapper = "_n2-e";
export var pointer = "_n2-2";
export var showOverflow = "_n2-f";
export var tagsFlex = "_n2-d";
export var xButton = "_n2-g";